import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRe160 {
  // GET parameters
  export namespace Get {

    export interface Request {
      query: {
        monthlyCheckId: string
      }
    }

    interface monthlyLearningInfoObject {
      subjectId: string,
      name: string,
      learningProgress: number
    }

    export interface Response {
      memNum: string,
      grade: number,
      fiscalYear: number,
      dispMonth: number,
      monthlyLearningInfo: monthlyLearningInfoObject[],
      firstChoiceJuniorHighSchool: string
    }
  }

  // API Path
  const path: string = '/ta/monthlyCheck/learningHistory'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    public get<R>(params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

        // 成功時のレスポンス構造サンプル
        const validationSample: Get.Response = {
          memNum: '',
          grade: 0,
          fiscalYear: 0,
          dispMonth: 0,
          monthlyLearningInfo: [{
            subjectId: '',
            name: '',
            learningProgress: 0
          }],
          firstChoiceJuniorHighSchool: ''
        }

        // エラー時のレスポンス構造サンプル
        const validationErrorSample: ResponseError = {
          error: {
            messageId: '',
            message: ''
          }
        }

        // API呼び出し
        return this.callbackWrapper<Get.Response, ResponseError, R>(
          api.get<Get.Response>(path, { params: params.query }),
          successHandler,
          errorHandler,
          validationSample,
          validationErrorSample
        )
      }
  }
}
